<template>
  <modal 
    name="map-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'650px'"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        {{ address }}
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('map-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body" style="height:450px;">
      <template v-if="this.center != null">
        <l-map :zoom="zoom" :center="center">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker :lat-lng="marker"></l-marker>
        </l-map>
      </template>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios'

  export default {

    data() {
      return {
        address    : null,
        zoom       : 13,
        center     : null,
        url        :'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        marker     : null
      }
    },

    methods : {
      beforeOpen(event) {
        this.address = event.params.address
        this.center  = null
        this.marker  = null

        axios.get(location.protocol + '//nominatim.openstreetmap.org/search', {
          params : {
            format : 'json',
            q : event.params.address
          },
        }).then(response => {
          if(response.data != null && response.data.length > 0) {
            this.center = L.latLng(response.data[0].lat, response.data[0].lon)
            this.marker = L.latLng(response.data[0].lat, response.data[0].lon)
          }
        }).catch(e => {
          // callback()
          // this.errors.push(e)
        })
      },
    }
  }
</script>